import { render } from "./BoardThumb.vue?vue&type=template&id=51b81477"
import script from "./BoardThumb.vue?vue&type=script&lang=js"
export * from "./BoardThumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__